import { useEffect, useState } from 'react'

import { AuthPanelCode, AuthPanelEmail, AuthPanelPassword, AuthPanelProfile } from '@/features/auth'
import { AdvertisingCard } from '@/widgets/advertising-card'

const useCatalogIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 768)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return isMobile
}

export const AuthPanelEmailCatalogPreview = () => {
  const isMobile = useCatalogIsMobile()
  return <AuthPanelEmail variant={isMobile ? 'mobile' : 'desktop'} />
}

export const AuthPanelCodeCatalogPreview = () => {
  const isMobile = useCatalogIsMobile()
  return (
    <AuthPanelCode
      variant={isMobile ? 'mobile' : 'desktop'}
      codeValue=""
      onCodeChange={() => undefined}
    />
  )
}

export const AuthPanelPasswordCatalogPreview = () => {
  const isMobile = useCatalogIsMobile()
  return <AuthPanelPassword variant={isMobile ? 'mobile' : 'desktop'} />
}

export const AuthPanelProfileCatalogPreview = () => {
  const isMobile = useCatalogIsMobile()
  return (
    <AuthPanelProfile
      variant={isMobile ? 'mobile' : 'desktop'}
      onBack={() => undefined}
      onSubmit={() => undefined}
      onBottomLinkClick={() => undefined}
    />
  )
}

const MobileAdvertisingIcon = ({
  color,
  width,
  height,
  strokeWidth,
}: {
  color: string
  width: string
  height: string
  strokeWidth: string
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth={strokeWidth} />
    <path
      d="M10 10.0554C10 9.1768 10.9792 8.65277 11.7102 9.14011L14.6271 11.0847C15.2802 11.5201 15.2802 12.4799 14.6271 12.9153L11.7102 14.8599C10.9792 15.3472 10 14.8232 10 13.9446V10.0554Z"
      stroke={color}
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const AdvertisingCardCatalogPreview = () => {
  const isMobile = useCatalogIsMobile()
  return (
    <AdvertisingCard
      variant={isMobile ? 'mobile' : 'desktop'}
      title="Видеоплатформа с кейсами"
      description={
        isMobile
          ? undefined
          : 'Экспертные доклады про рост метрик, маркетинг, дизайн, нейросети, управление командой — все, что поможет растить бизнес.'
      }
      ctaLabel={isMobile ? undefined : 'Смотреть кейсы'}
      icon={isMobile ? MobileAdvertisingIcon : undefined}
    />
  )
}

